import service from '../index';
import config from '@/assets/config.json';

/**
 * @亲子项目门票数据统计
 * 
 * @config.babyHttps.api 
*/

const token = localStorage.getItem('Beitoken')

 // 获取图表数据
export function getEcharts(params) {
    const url = config.babyHttps.api + '/apitravel/admin/statistics/map';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

 // 获取景区统计数据
export function getStatistics(params) {
    const url = config.babyHttps.api + '/apitravel/admin/statistics/order';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}